<template>
  <v-list-item-avatar class="profile-avatar ma-0" :size="size">
    <v-img v-if="profilePicture" v-bind:src="profilePicture" />
    <v-icon v-else :size="size * 1.2"> mdi-account-circle </v-icon>
  </v-list-item-avatar>
</template>

<style scoped>
/* Disables some funky Vuetify styling */
.v-application--is-ltr .v-list-item__avatar:first-child {
  margin: 0;
}
</style>

<script>
export default {
  name: "profile-avatar",

  data: () => ({
    retrievedProfilePic: "",
  }),

  computed: {
    profilePicture() {
      return this.presetProfilePic ? this.presetProfilePic : this.retrievedProfilePic;
    },
  },

  props: {
    size: { type: Number, default: 64 },
    username: { type: String, default: "" },
    opaque: { type: Boolean, defautl: false },
    presetProfilePic: { type: String, default: undefined },
  },

  watch: {
    username: function () {
      this.getProfile();
    },
  },

  methods: {
    getUsername: function () {
      if (this.username) return this.username;
      else return this.$store.state.username;
    },

    getProfile: function () {
      this.$axios
        .get("/profile", {
          params: { user: this.getUsername() },
        })
        .then((response) => {
          this.retrievedProfilePic = response.data.profile_pic;
        })
        .catch(() => {});
    },
  },

  mounted: function () {
    if (this.presetProfilePic === undefined) {
      this.getProfile();
    }
  },
};
</script>
